'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_intelacloud_Page() {
}
export { $c_Lio_intela_sites_intelacloud_Page as $c_Lio_intela_sites_intelacloud_Page };
$p = $c_Lio_intela_sites_intelacloud_Page.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_intelacloud_Page;
/** @constructor */
function $h_Lio_intela_sites_intelacloud_Page() {
}
export { $h_Lio_intela_sites_intelacloud_Page as $h_Lio_intela_sites_intelacloud_Page };
$h_Lio_intela_sites_intelacloud_Page.prototype = $p;
$p.O = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
//# sourceMappingURL=io.intela.sites.intelacloud.-Page.js.map
